export enum MonitoringBulkActionSourceMethodEnum {
    'SELECTION',
    'SEARCH'
}
